import 'restangular';

export default angular.module('app.resource', [
  'restangular'
])
.service('Resource', function (Restangular, $cacheFactory) {
  const httpCache = $cacheFactory.get('$http');
  return function (resourceName, options = {}) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      if (options.baseUrl) {
        RestangularConfigurer.setBaseUrl(options.baseUrl);
      }

      RestangularConfigurer
        .addResponseInterceptor(function (data, operation, what) {
          if (what != resourceName)
            return data;

          switch (operation) {
            case 'getList':
              return options.deserialize ? data.map(options.deserialize) : data;
            case 'get':
            case 'post':
            case 'put':
              return options.deserialize ? options.deserialize(data) : data;
            default:
              return data;
          }
        })
        .addRequestInterceptor(function (data, operation, what) {
          if (what != resourceName)
            return data;

          switch (operation) {
            case 'post':
            case 'put':
              return options.serialize ? options.serialize(data) : data;
            default:
              return data;
          }
        })
        .addRequestInterceptor(function (data, operation, what) {
          if (what != resourceName)
            return data;

          switch (operation) {
            case 'post':
              !/(audiences|segment-analytics)\/.*_preview/.test(what) && httpCache.removeAll();
              return data;
            case 'put':
              httpCache.removeAll();
              return data;
            case 'remove':
              httpCache.removeAll();
              return data;
            default:
              return data;
          }
        })
        .setDefaultHttpFields((() => {
          return {cache: options.cachingAtive == true};
        })());
    }).service(resourceName);
  }
})


/** WEBPACK FOOTER **
 ** ./src/resources/resource.js
 **/